import { Component, Input } from "@angular/core";
import { SaleDocTender } from "../sale-doc-tender/sale-doc-tender";

@Component({
  selector: "taku-pay-type-details",
  templateUrl: "./pay-type-details.component.html",
  styleUrls: ["./pay-type-details.component.scss"],
})
export class PayTypeDetailsComponent {
  // 1. Inputs & Outputs (Public API của Component)
  @Input() saleDocTenders: SaleDocTender[];

  // 2. Readonly Constants / Configs / Lookup Tables
  readonly decimalFormat = "1.2-2";
  readonly paymentTypeLabels: Record<string, string> = {
    card_present: "CP",
    card_not_present: "CNP",
    card_not_present_moto: "CNP MOTO",
    card_token: "CNP TOKEN",
  };

  // 3. Component State Properties (let/var)

  // 4. Constructor & Lifecycle Hooks (ngOnInit, ngOnChanges, ...)

  // 5. Public / Private Methods
}
